<template>
  <v-data-table
    :headers="headers"
    :items="equipos"
    sort-by="calories"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>Totales</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
          <!-- <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
              Editar Precios
            </v-btn>
          </template> -->
          <v-card>
            <v-card-title>
              <span class="text-h5">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="4">
                    <v-select
                      :items="editedItem.nombre"
                      v-model="editedItem.nombre"
                      label="Nombre"
                      dense
                      :keydown="addNombre(editedItem.nombre)"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="editedItem.empresa"
                      label="Empresa"
                      :keydown="addEmpresa(editedItem.empresa)"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="editedItem.instalaciones"
                      label="Instalaciones"
                      :keydown="addInstalaciones(editedItem.instalaciones)"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="editedItem.cambio_tecnologia"
                      label="Cambio de tecnologia"
                       :keydown="addCambio(editedItem.cambio_tecnologia)"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="editedItem.servicio_tecnico"
                      label="Servicio técnico"
                       :keydown="addServicio(editedItem.servicio_tecnico)"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="editedItem.total_mes"
                      label="Total del mes"
                       :keydown="addTotal(editedItem.total_mes)"
                    ></v-text-field>
                  </v-col>
                
                
                  
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">
                Cancelar
              </v-btn>
              <v-btn color="blue darken-1" text @click="save"> Guardar </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="text-h5"
              >¿Está seguro de borrar este item?</v-card-title
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete"
                >Cancelar</v-btn
              >
              <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                >OK</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:[`item.estado`]="{ item }">
      <v-chip class="ma-2" color="secondary">{{item.estado}}</v-chip>
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
      <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" > Reset </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import EquipoStore from "../store/index";
import { getAllTotales , addTotales }from '../database.js'
export default {
  name: "Totales",

  components: {},
  data: () => ({
    dialog: false,
    dialogDelete: false,
    headers: [
      {
        text: "Nombre",
        align: "start",
        sortable: false,
        value: "nombre",
      },
      { text: "Enero 2023", value: "1_2023" },
      { text: "Febrero 2023", value: "2_2023" },
      { text: "Marzo 2023", value: "3_2023" },
      { text: "Abril 2023", value: "4_2023" },
      { text: "Mayo 2023", value: "5_2023" },      
      { text: "Junio 2023", value: "6_2023" },      
      { text: "Julio 2023", value: "7_2023" },      
      { text: "Acciones", value: "actions", sortable: false },
    ],
    equipos: EquipoStore.data.totalesList,
    // asignados: ["Barney Gomez", "Jefe Gorgory", "Smithers"],
    // selectedAsignado: null,
    editedIndex: -1,
    editedItem: {
      nombre: EquipoStore.data.usuariosList,
      empresa: "",
      instalaciones:"",
      cambio_tecnologia: "",
      servicio_tecnico: "",
      total_mes: "",       
    },
    defaultItem: {
      nombre: "",
      empresa: "",
      instalaciones:"",
      cambio_tecnologia: "",
      servicio_tecnico: "",
      total_mes: "", 
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Item" : "Editar Item";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  async created() {
    // this.initialize();
      // await getAllTotales()
  },

  methods: {
  
    async editItem(item) {
      this.editedIndex = this.equipos.indexOf(item);
      this.editedItem = Object.assign({}, item);
      // EquipoStore.data.usuarios = this.editedItem
      this.dialog = true;
    
    },

    deleteItem(item) {
      this.editedIndex = this.equipos.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.equipos.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async save() {
      if (this.editedIndex > -1) {
        Object.assign(this.equipos[this.editedIndex], this.editedItem);
      } else {
        this.equipos.push(this.editedItem);
        console.log("item:", this.editedItem)
        // EquipoStore.methods.addnewdataTecnicos(this.editedItem)
        this.dialog = true;
        await addTotales()
        await getAllTotales()
      }
      this.close();
    },
    addNombre(data){
      console.log(data);
      let propiedad = "nombre";
      EquipoStore.methods.addnewdataTecnicos(propiedad, data);
      console.log("store: ",EquipoStore.data.tecnicos[0].nombre);
    },
    addEmpresa(data){
      console.log(data);
      let propiedad = "empresa";
      EquipoStore.methods.addnewdataTecnicos(propiedad, data);
      console.log("store: ",EquipoStore.data.tecnicos[0].empresa);
    },
    addInstalaciones(data){
      console.log(data);
      let propiedad = "instalaciones";
      EquipoStore.methods.addnewdataTecnicos(propiedad, data);
      console.log("store: ",EquipoStore.data.tecnicos[0].instalaciones);
    },
    addCambio(data){
      console.log(data);
      let propiedad = "cambio_tecnologia";
      EquipoStore.methods.addnewdataTecnicos(propiedad, data);
      console.log("store: ",EquipoStore.data.tecnicos[0].cambio_tecnologia);
    },
    addServicio(data){
      console.log(data);
      let propiedad = "servicio_tecnico";
      EquipoStore.methods.addnewdataTecnicos(propiedad, data);
      console.log("store: ",EquipoStore.data.tecnicos[0].servicio_tecnico);
    },
    addTotal(data){
      console.log(data);
      let propiedad = "total_mes";
      EquipoStore.methods.addnewdataTecnicos(propiedad, data);
      console.log("store: ",EquipoStore.data.tecnicos[0].total_mes);
    },
    
  },
};
</script>